import React, { FC, useCallback, useState } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import styles from './getIntroRequestsModalStyles.scss';

const GetIntroRequestsModal: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        className={styles.introRequestsModalLink}
        onClick={() => setIsModalOpen(true)}
        text="How to get more introduction requests"
        type={BUTTON_TYPES.LINK}
      />
    ),
    []
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      title="How to Receive More Introduction Requests"
    >
      <p>
        Every 6 months, you automatically receive <strong>7 Get Introduced Requests.</strong> These
        Requests do not accrue. You are under no obligation to use all of your allotted Requests. If
        you wish to acquire more Requests, there are currently two ways you can do so in a given 6
        month period:
      </p>
      <ol>
        <li>
          <p>
            If an analyst at your firm <strong>posts an idea to the Research Database</strong>{' '}
            within the last 6 months (and it remains active), you will earn 3 more Get Introduced
            Requests for that period.
          </p>
        </li>
        <li>
          <p>
            If your profile&nbsp;
            <strong>maintains a 90% completeness score or higher over 60 consecutive days</strong>
            &nbsp;during the respective 6-month period, you will earn 3 more Requests for that
            period.
          </p>
        </li>
      </ol>
      <p>
        Should you decide to capitalize on both of these "bonuses" your firm will automatically
        receive a total of <strong>13 Get Introduced Requests</strong> every 6 months.
      </p>
    </Modal>
  );
};

export default GetIntroRequestsModal;
